import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from "@angular/core";
import * as _moment from "moment";
import { Observable, Subscription } from "rxjs";
import { ReintegrosService } from "src/app/services/reintegros.service";
import { SubjectService } from "src/app/services/subject.service";
const moment = (_moment as any).default ? (_moment as any).default : _moment;
declare let $: any;

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"]
})
export class SearchComponent implements OnInit, OnDestroy {

  public today = new Date();
  public initDate = new Date(new moment(this.today).subtract(3, "months"));
  public min = new Date("2016-01-02");
  public max = new Date();

  public dataWebContracts: any;
  public data = {};
  public selectedMoments = [this.initDate, this.today];
  public dataSearch = {
    contract: "",
    initDate: this.initDate,
    endDate: this.today,
    dateHasChanged: false
  };

  @Output() search: EventEmitter<object> = new EventEmitter();
  @Input() contract = false;

  @Input() showContractInput: boolean = true;
  @Input() showDateRangeInput: boolean = true;
  public subs1: Subscription;
  public stateContract$: Observable<string> = this.subject.stateContract$;

  constructor(private reintegrosService: ReintegrosService, public subject: SubjectService) {
    this.subs1 = this.stateContract$.subscribe(
      (contract) => {
         this.dataSearch.contract = contract;
      }
    );
  }

  ngOnInit() {
    if (this.contract) {
      this.webContracts();
    } else {
      this.handleSearch();
    }
  }

  ngOnDestroy() {
    this.subs1.unsubscribe();
  }

  handleSearch() {
    this.dataSearch.initDate = this.selectedMoments[0];
    this.dataSearch.endDate = this.selectedMoments[1];
    this.dataSearch.dateHasChanged = this.validateDateChange();
    this.search.emit(this.dataSearch);
  }

  handleChangeContract(contract: string) {
   this.subject.changeStateContract(contract);
  }

  validateDateChange() {
    if (
      this.initDate !== this.dataSearch.initDate ||
      this.today !== this.dataSearch.endDate
    ) {
      return true;
    } else {
      return false;
    }
  }

  webContracts() {
    this.reintegrosService.getWebContracts(this.data).subscribe(
      (resp: any) => {
        this.dataWebContracts = resp.CONSULTA_CONTRATOS_WEB;
        if (
          this.dataWebContracts &&
          this.dataWebContracts[0] &&
          this.dataWebContracts.length >= 1
        ) {
          this.dataSearch.contract = this.dataWebContracts[0].contrato;
          this.handleSearch();
        }
      },
      (err: any) => {
        console.error(err);
        this.dataWebContracts = [];
      }
    );
  }
}
